<template>
	<div class="about-main">


		<div class="title">
			<span class="wi8_font">What I Ate!</span> &nbsp; Food. &nbsp; Fun. &nbsp; Publog.
		</div>

		<div class="title">
			Created by Dynamic Arts
		</div>

		<a href="https://dynamicarts.com/" target="_blank">
			<div class="link_box">
				<div class="logo_box">
					<UniIcon 
						ico="logo_da" 
						fit="1"
					/>
				</div>
				<div class="logo_title">
					Visit Dynamic Arts
				</div>
			</div>
		</a>

		<hr />


		<a href="https://vuejs.org/" target="_blank">
			<div class="link_box">
				<div class="logo_box">
					<UniIcon 
						ico="logo_vue" 
						fit="1"
					/>
				</div>
				<div class="logo_title">
					Built using Vue.js
				</div>
			</div>
		</a>

		<hr />


		<a href="http://www.flaticon.com/" target="_blank">
			<div class="link_box">
				<div class="logo_box">
					<UniIcon 
						ico="logo_flaticon" 
						fit="1"
					/>
				</div>
				<div class="logo_title">
					Many icons: Flaticon and Freepik
				</div>
			</div>
		</a>


	</div>
</template>

<script>
import { eventBus } from '@/main';
export default {
	created() {
		eventBus.$emit('popoffall'); // Close all modal windows
	},
}
</script>

<style scoped>
	.about-main {
		height: 100%;
		overflow: hidden;
		color: #369;
		text-align: center;
		padding: 20px;
		background-color: #F6F6F6;
		border: solid 0px #090;
	}
	a {
		color: #369;
	    text-decoration:none;
	}
	.title {
		height: 40px;
		overflow: hidden;
		font-size: 20px;
		border: solid 0px #369;
	}
	.link_box {
		height: 80px;
		overflow: hidden;
		/* margin: auto; */
		cursor: pointer;
		padding: 0px 0px 0px 0px;
		border: solid 0px #369;
		/* border-bottom:solid 1px #369; */
	}
	.logo_box {
		display: inline-block;
		width: 80px;
		height: 64px;
		overflow: hidden;
		text-align: left;
		border: solid 0px #C30;
	}
	.logo_title {
		display: inline-block;
		width: 220px;
		height: 64px;
		overflow: hidden;
		text-align:left;
		padding: 20px 0px 0px 10px;
		border: solid 0px #090;
	}

</style>
